import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, LogIn, Loader2 } from "lucide-react";
import { adminLogin } from "@/lib/admin";

export default function AdminLogin() {
    const [passcode, setPasscode] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await adminLogin(passcode);
            toast.success("Welcome to the admin dashboard.");
            navigate("/admin/dashboard", { replace: true });
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Invalid passcode.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <section data-testid="admin-login" className="min-h-[80vh] bg-[#101A2C] text-white flex items-center grain-overlay">
            <div className="container-vl py-20 grid grid-cols-12 gap-10 items-center">
                <div className="col-span-12 lg:col-span-6">
                    <p className="overline mb-4">Internal · Authorised access only</p>
                    <h1 className="heading-h1 text-white mb-5">Admin Console</h1>
                    <p className="text-[#CBD5E1] max-w-lg leading-relaxed">
                        Sign in with your team passcode to review and manage incoming logistics leads — transportation requests, warehousing inquiries, consultations, contact messages and career applications.
                    </p>
                </div>
                <div className="col-span-12 lg:col-span-5 lg:col-start-8">
                    <form
                        onSubmit={onSubmit}
                        data-testid="admin-login-form"
                        className="bg-white text-[#101A2C] p-8 md:p-10 border-l-4 border-[#F4A000]"
                    >
                        <div className="flex items-center gap-3 mb-7">
                            <span className="w-11 h-11 inline-flex items-center justify-center bg-[#28406A] text-white">
                                <Lock className="h-5 w-5" strokeWidth={1.5} />
                            </span>
                            <div>
                                <p className="overline">Secure Sign-in</p>
                                <p className="font-display uppercase text-lg">Team Passcode</p>
                            </div>
                        </div>
                        <label className="label-vl">Passcode</label>
                        <input
                            type="password"
                            data-testid="admin-passcode"
                            className="input-vl mb-6"
                            value={passcode}
                            onChange={(e) => setPasscode(e.target.value)}
                            autoComplete="current-password"
                            required
                        />
                        <button
                            type="submit"
                            disabled={loading || !passcode}
                            data-testid="admin-login-submit"
                            className="btn-primary w-full justify-center disabled:opacity-60"
                        >
                            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <LogIn className="h-4 w-4" />}
                            {loading ? "Signing in…" : "Sign In"}
                        </button>
                        <p className="mt-5 text-[11px] text-[#4B6390] tracking-wide">
                            For internal Vibhuti team use. Unauthorised attempts are logged.
                        </p>
                    </form>
                </div>
            </div>
        </section>
    );
}
